var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislikeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_filled",
    d: "M16.9 27.7l6.5 5.7L26 40h4.3V29.4h8.6v-6l-4-10.2h-18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M10.9 26.9V13.2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeFilled);
export default __webpack_public_path__ + "static/media/dislikeFilled.8a6bbcdf11312be910a36ea63dd66b30.svg";
export { ForwardRef as ReactComponent };